import React, { useState, useEffect } from 'react';
import { IPlayer } from 'interfaces/team/IPlayer';
import { observer } from 'mobx-react-lite';
import { SearchBar } from 'components/ui/SearchBar/SearchBar';
import { LineupManager } from 'models/setLineup/LineupManager';
import { RosterPlayer } from './RosterPlayer/RosterPlayer';
import { RosterPlayers, RosterWrapper } from './RosterStyles';

interface IProps {
  lineupManager: LineupManager;
  unavailablePlayerIds: string[];
  size: 'sm' | 'lg';
}

export const Roster: React.FC<IProps> = observer(({ lineupManager, unavailablePlayerIds, size }) => {
  return (
    <RosterWrapper className='roster'>
      <RosterPlayers className='roster-players'>
        {lineupManager.roster.map((player: IPlayer, index) => {
          return (
            <RosterPlayer
              key={index}
              index={index}
              player={player}
              addPlayerToLineup={lineupManager.addPlayerToLineup}
              removePlayerFromLineup={lineupManager.removePlayerFromLineup}
              isInLineup={lineupManager.isPlayerInLineup(player)}
              isUnavailable={unavailablePlayerIds.includes(player.id)}
              size={size}
              lineup={lineupManager.lineup}
            />
          );
        })}
      </RosterPlayers>
    </RosterWrapper>
  );
});
